import apiClient from "../../client/apiClient"

// ── Types ──────────────────────────────────────────────────────────
export type ApprovalItem = {
  id: string
  title: string
  status: string
  session_name: string
  campus_name: string
  exam_term_name: string
}

export type ReviewSubject = {
  course_structure_id: string
  class_name: string
  subject_name: string
  include_in_total: boolean
  student_count: number
  subcategory_count: number
  expected_marks: number
  entered_marks: number
  is_carryover_final: boolean
  final_calculations: number
  ready: boolean
}

export type ReviewAction = {
  id: string
  action: string
  actor_name: string | null
  actioned_at: string
  notes: string | null
}

export type ReviewData = {
  breakdown: { id: string; title: string; status: string }
  subjects: ReviewSubject[]
  all_ready: boolean
  recent_actions: ReviewAction[]
}

const BASE = "/approvals"

// Breakdowns awaiting review (submitted / needs_revision).
export const listApprovals = async (): Promise<{ success: boolean; items: ApprovalItem[] }> => {
  const res = await apiClient({ method: "GET", url: BASE })
  return res.data
}

// Per-subject completeness review for one breakdown.
export const reviewApproval = async (
  id: string
): Promise<{ success: boolean } & ReviewData> => {
  const res = await apiClient({ method: "GET", url: `${BASE}/${id}/review` })
  return res.data
}

export const submitApproval = async (id: string) => {
  const res = await apiClient({ method: "POST", url: `${BASE}/${id}/submit` })
  return res.data
}

export const approveApproval = async (id: string) => {
  const res = await apiClient({ method: "POST", url: `${BASE}/${id}/approve` })
  return res.data
}

export const requestRevisionApproval = async (id: string, notes?: string) => {
  const res = await apiClient({ method: "POST", url: `${BASE}/${id}/request-revision`, data: { notes } })
  return res.data
}

export const publishApproval = async (id: string) => {
  const res = await apiClient({ method: "POST", url: `${BASE}/${id}/publish` })
  return res.data
}
